import React     from 'react';
import PropTypes from 'prop-types';

class Block extends React.Component {
	render() {

		const blockProps = {
			className: [Block.BASE_CLASS, this.props.className].join(' '),
			style: {...this.props.additionalStyle},
			id: this.props.idName,
		};

		if (this.props.backgroundImage.length !== 0) {
			blockProps.style.backgroundImage = `url('${this.props.backgroundImage}')`;
		}

		if (this.props.gradient !== false) {
			blockProps.style.backgroundImage = blockProps.style.backgroundImage + `, ${this.props.gradient}`;
		}

		return (
			<section {...blockProps}>
				{this.props.children}
			</section>
		);
	}
}

Block.propTypes = {
	className:       PropTypes.string,
	idName:          PropTypes.string,
	backgroundImage: PropTypes.string,
	children:        PropTypes.oneOfType([
		PropTypes.node,
		PropTypes.arrayOf(PropTypes.node),
	]),
	gradient:        PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.bool,
	]),
	additionalStyle: PropTypes.object,
};

Block.defaultProps = {
	className:       '',
	children:        [],
	backgroundImage: '',
	gradient:        false,
	additionalStyle: {},
};

Block.BASE_CLASS = 'homepage-block';

export default Block;
